
import { BalanceSheetOverviewData } from "@/types/balance-sheet-overview.api";
import { api, withErrorHandling } from "./api";
import qs from 'qs';

export const getBalanceSheetOverview = async (
    clientId: string,
    connectionIds: string[],
    months: number[],
    year: number
): Promise<BalanceSheetOverviewData> => {
    const response = await withErrorHandling(() =>
        api.get<BalanceSheetOverviewData>(`/clients/${clientId}/report/balance-sheet`, {
            params: {
                clientId: clientId,
                connectionIds: connectionIds[0],
                Year: year,
                Month: months[months.length - 1],
            },
            paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
        })
    );

    return response.data;
};